import ApiService from '../../../../../../services/ApiService'

export default {
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.values = [this.institutionId]
    this.getInstitutions()
    this.getDepartments()
    this.getStandardEquipment()
    await this.getUnidades()

    if (this.institution.userType == 5) {
      this.unidadeSelected = this.unidades.filter(
        (x) => x.id === this.userLogged.unidadeId
      )
    }

    const currentYear = new Date().getFullYear()
    this.years.unshift(currentYear)

    for (let i = 0; i < 3; i++) {
      const year = currentYear - i
      this.years.unshift(year)
    }

    for (let i = 0; i < 3; i++) {
      const year = currentYear + i
      this.years.push(year)
    }

    this.year = currentYear

    this.format = this.formats[0]

    await this.loadPreset()
  },

  data: () => ({
    presetLoading: false,
    hasSavedPreset: false,
    correctiveMaintenanceEquipment: false,
    departmentSearch: '',
    unitySearch: '',
    institution: {},
    typeSearch: '',
    identification: '',
    propertyCode: '',
    searchInput: '',
    values: [],
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    departmentLoading: false,
    standardEquipmentLoading: false,
    menu: false,
    date: null,
    month: null,
    year: null,
    format: null,
    responsibility: null,
    institutionId: null,
    search: null,
    institutions: [],
    selectedInstitutions: [],
    unidadeSelected: [],
    unidades: [],
    standardEquipmentSelected: [],
    standardEquipment: [],
    departmentSelected: [],
    departments: [],
    serviceOrderTypeSelected: [],
    userLogged: {},
    apiService: new ApiService(),
    serviceOrderTypes: [
      {
        name: 'Treinamento',
        value: 0,
      },
      {
        name: 'Segurança elétrica',
        value: 1,
      },
      {
        name: 'Preventiva',
        value: 2,
      },
      {
        name: 'Calibração',
        value: 6,
      },
      {
        name: 'Validação/Qualificação',
        value: 7,
      },
    ],
    responsibilities: ['Interna', 'Externa'],
    months: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    years: [],
    formats: ['HTML', 'Excel', 'PDF'],
    state: null,
    states: [
      { text: 'Agendada', value: 0 },
      { text: 'Executada dentro do prazo', value: 1 },
      { text: 'Executada fora do prazo', value: 2 },
      { text: 'Atrasada', value: 3 },
    ],
  }),

  components: {},

  computed: {
    icon() {
      if (this.likesAllInstitution) return 'mdi-close-box'
      if (this.likesSomeInstitution) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    likesSomeInstitution() {
      return this.values.length > 0 && !this.likesAllInstitution
    },
    likesAllInstitution() {
      return this.values.length === this.institutions.length
    },
    filteredInstitutions() {
      if (!this.searchInput || this.searchInput.trim() === '') {
        return this.institutions
      }
      return this.institutions.filter((institution) =>
        institution.name.toLowerCase().includes(this.searchInput.toLowerCase())
      )
    },
    filteredIcon() {
      if (this.isAllFilteredSelected) return 'mdi-close-box'
      if (this.isSomeFilteredSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    isAllFilteredSelected() {
      if (this.filteredInstitutions.length === 0) return false
      return this.filteredInstitutions.every((institution) =>
        this.values.includes(institution.id)
      )
    },
    isSomeFilteredSelected() {
      if (this.filteredInstitutions.length === 0) return false
      return (
        this.filteredInstitutions.some((institution) =>
          this.values.includes(institution.id)
        ) && !this.isAllFilteredSelected
      )
    },
    subDepartments() {
      const departments = this.localDepartments.filter(
        (x) =>
          this.filter.equipmentDepartmentIds &&
          this.filter.equipmentDepartmentIds.includes(x.id)
      )

      return departments.map((x) => x.subDepartments).flat(1)
    },
  },

  methods: {
    removeUnidade(item) {
      this.unidadeSelected.splice(this.unidadeSelected.indexOf(item), 1)
      this.unidadeSelected = [...this.unidadeSelected]
    },
    removeInstitution(item) {
      this.values.splice(this.values.indexOf(item), 1)
      this.values = [...this.values]
    },

    removeStandardEquipment(item) {
      this.standardEquipmentSelected.splice(
        this.standardEquipmentSelected.indexOf(item),
        1
      )
      this.standardEquipmentSelected = [...this.standardEquipmentSelected]
    },

    removeServiceOrderType(item) {
      this.serviceOrderTypeSelected.splice(
        this.serviceOrderTypeSelected.indexOf(item),
        1
      )
      this.serviceOrderTypeSelected = [...this.serviceOrderTypeSelected]
    },

    removeDepartment(item) {
      this.departmentSelected.splice(this.departmentSelected.indexOf(item), 1)
      this.departmentSelected = [...this.departmentSelected]
    },

    removeStatus(item) {
      this.state.splice(this.state.indexOf(item), 1)
      this.state = [...this.state]
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/listuser')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch(() => {
          this.institutionLoading = false
        })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .post(`bigdata/unidade`, this.values)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
        .catch(() => {
          this.unidadeLoading = false
        })
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      await this.apiService
        .get(`standardEquipment/list`)
        .then((response) => {
          this.standardEquipment = response.content
          this.standardEquipmentLoading = false
        })
        .catch(() => {
          this.standardEquipmentLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .post(`bigdata/department`, this.values)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
        .catch(() => {
          this.departmentLoading = false
        })
    },

    async scheduleExport() {
      this.loading = true

      const types = this.serviceOrderTypeSelected

      const filter = {
        idEquipment: this.identification,
        propertyCode: this.propertyCode,
        institutionIds: this.values,
        InstitutionId: this.institutionId,
        Unidades: this.unidadeSelected,
        StandardEquipmentIds: this.standardEquipmentSelected,
        ServiceOrderTypes: types,
        Departments: this.departmentSelected,
        Month: this.months.indexOf(this.month) + 1,
        Year: this.year,
        ExportType: this.format == 'HTML' ? 'Front' : this.format,
        Responsibility:
          this.responsibility != null
            ? this.responsibilities.indexOf(this.responsibility)
            : null,
        BaseUrl: 'https://app.fixsystem.io',
        isBigData: true,
        ChronogramStatus: this.correctiveMaintenanceEquipment
          ? this.state
            ? [...this.state, 4]
            : [4]
          : this.state,
      }

      await this.apiService
        .post('bigdata/scheduleExport', filter)
        .then((response) => {
          localStorage.removeItem('scheduleFilters')
          localStorage.setItem('scheduleFilters', JSON.stringify(filter))
          window.open('/schedule', '_blank')

          if (this.format == 'PDF') {
            var pdfResult =
              'data:application/pdf;base64,' + response.content.pdf
            const link = document.createElement('a')
            link.href = pdfResult
            link.setAttribute('download', `Cronograma ${this.year}`)
            document.body.appendChild(link)
            link.click()
          }

          if (this.format == 'Excel') {
            var excelResult = `data:application/octet-stream;base64,${response.content.excel}`
            const link = document.createElement('a')
            link.href = excelResult
            link.setAttribute('download', `Cronograma ${this.year}.xlsx`)
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch((err) => {})

      this.loading = false
    },

    async planningExport() {
      this.loading = true

      await this.apiService
        .get('equipment/exportPlanningExcel')
        .then((response) => {
          const base64String = response.content
          const excelResult = `data:application/octet-stream;base64,${base64String}`
          const link = document.createElement('a')
          link.href = excelResult
          link.setAttribute('download', `Planejamentos.xlsx`)
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {
          console.error('Erro ao exportar planejamentos:', err)
        })

      this.loading = false
    },

    reset() {
      if (this.institution.userType == 5) {
        this.unidadeSelected = this.unidades.filter(
          (x) => x.id === this.userLogged.unidadeId
        )
      } else {
        this.unidadeSelected = []
      }

      this.standardEquipmentSelected = []
      this.serviceOrderTypeSelected = []
      this.departmentSelected = []
      this.month = null
      this.year = new Date().getFullYear()
      this.format = this.formats[0]
      this.responsibility = null
      this.values = []
      this.state = null
    },

    getPresetData() {
      return {
        values: this.values,
        unidadeSelected: this.unidadeSelected,
        standardEquipmentSelected: this.standardEquipmentSelected,
        serviceOrderTypeSelected: this.serviceOrderTypeSelected,
        departmentSelected: this.departmentSelected,
        identification: this.identification,
        propertyCode: this.propertyCode,
        month: this.month,
        year: this.year,
        format: this.format,
        responsibility: this.responsibility,
        state: this.state,
        correctiveMaintenanceEquipment: this.correctiveMaintenanceEquipment,
      }
    },

    applyPreset(data) {
      if (data.values !== undefined) this.values = data.values
      if (data.unidadeSelected !== undefined) this.unidadeSelected = data.unidadeSelected
      if (data.standardEquipmentSelected !== undefined) this.standardEquipmentSelected = data.standardEquipmentSelected
      if (data.serviceOrderTypeSelected !== undefined) this.serviceOrderTypeSelected = data.serviceOrderTypeSelected
      if (data.departmentSelected !== undefined) this.departmentSelected = data.departmentSelected
      if (data.identification !== undefined) this.identification = data.identification
      if (data.propertyCode !== undefined) this.propertyCode = data.propertyCode
      if (data.month !== undefined) this.month = data.month
      if (data.year !== undefined) this.year = data.year
      if (data.format !== undefined) this.format = data.format
      if (data.responsibility !== undefined) this.responsibility = data.responsibility
      if (data.state !== undefined) this.state = data.state
      if (data.correctiveMaintenanceEquipment !== undefined)
        this.correctiveMaintenanceEquipment = data.correctiveMaintenanceEquipment
    },

    async loadPreset() {
      if (!this.userLogged.id) return
      try {
        const response = await this.apiService.get(
          `bigDataFilterPreset/${this.userLogged.id}/0`,
          null,
          false,
          false
        )
        if (response && response.content) {
          this.applyPreset(JSON.parse(response.content.filterJson))
          this.hasSavedPreset = true
        }
      } catch (_) {}
    },

    async savePreset() {
      this.presetLoading = true
      try {
        await this.apiService.post('bigDataFilterPreset', {
          userId: this.userLogged.id,
          tab: 0,
          filterJson: JSON.stringify(this.getPresetData()),
        })
        this.hasSavedPreset = true
        this.$toast.success('Filtro salvo com sucesso!')
      } catch (_) {
        this.$toast.error('Erro ao salvar filtro')
      }
      this.presetLoading = false
    },

    async removePreset() {
      this.presetLoading = true
      try {
        await this.apiService.delete(
          `bigDataFilterPreset/${this.userLogged.id}/0`,
          null,
          false,
          false
        )
        this.hasSavedPreset = false
        this.$toast.success('Filtro salvo removido!')
      } catch (_) {
        this.$toast.error('Erro ao remover filtro')
      }
      this.presetLoading = false
    },

    toggle() {
      this.$nextTick(() => {
        if (this.likesAllInstitution) {
          this.values = []
        } else {
          this.values = this.institutions.map((x) => x.id).slice()
        }
      })
    },

    toggleFilteredInstitutions() {
      this.$nextTick(() => {
        const filteredIds = this.filteredInstitutions.map((x) => x.id)
        if (this.isAllFilteredSelected) {
          // Deselect all filtered institutions
          this.values = this.values.filter((id) => !filteredIds.includes(id))
        } else {
          // Select all filtered institutions
          const newValues = [...new Set([...this.values, ...filteredIds])]
          this.values = newValues
        }
      })
    },
  },

  watch: {
    standardEquipmentSelected() {
      this.search = ''
    },
    values(nv, ov) {
      if (nv) {
        this.getUnidades()
        this.getDepartments()
        this.getStandardEquipment()
      }
    },
  },
}
